import type { ReactNode } from 'react';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { Background } from '@/features/styles/components/Background';
import { useStyles } from '@/features/styles/hooks/useStyles';
import { usePrintStyles } from '@/features/styles/lib/printStyles';
import { ExperienceTypes } from '@/types/gql.generated';
import { Flex } from '@/ui';
import { Page } from './Page';

type LayoutContainerProps = {
  children: ReactNode;
};

export const LayoutContainer = ({ children }: LayoutContainerProps) => {
  const { cssVariables } = useStyles();
  const { presets } = usePrintStyles();
  const { experience } = usePageExperienceContext();
  const isPlanner = experience?.type === ExperienceTypes.Planner;

  const plannerPx = isPlanner
    ? {
        base: 0,
        sm: 'var(--chakra-space-2)',
        md: 'var(--experience-page-padding)',
      }
    : undefined;

  return (
    <Page
      px={plannerPx}
      sx={{
        ...cssVariables,
        ...presets.calendarLayout(),
      }}
    >
      <Flex
        direction="column"
        gap="var(--experience-block-spacing)"
        maxW="var(--experience-page-max-width)"
        mx="auto"
        w="100%"
      >
        {children}
      </Flex>
      <Background />
    </Page>
  );
};
